import { FaLinkedin } from 'react-icons/fa';
import peter from '../assets/team/PeterDeClercq.jpg';
import wim from '../assets/team/WimHautekiet.jpg';
import olly from '../assets/team/OllyBuxton.jpg';
import pavel from '../assets/team/PavelPluhacek.jpg';
import cecile from '../assets/team/CecileVanHentenryck.png';
import nicolas from '../assets/team/NicolasSchepkens.png';

const team = [
  {
    id: 'team-member-1',
    icon: <FaLinkedin />,
    linkedin: 'https://www.linkedin.com/in/ukpeterdeclercq/',
    email: 'peter.declercq@quantessence.com',
    image: peter,
  },
  {
    id: 'team-member-3',
    icon: <FaLinkedin />,
    linkedin: 'https://www.linkedin.com/in/wim-hautekiet-8034632/',
    name: 'Wim Hautekiet',
    title: 'Chief Risk & Compliance Officer',
    description: (
      <>
        Wim is Chief Risk and Compliance Officer and member of the Management Committee. 
        He has served on the Board since 2015, first as a non-executive director, and at the end of 2021 he transitioned to his current executive role when Quantessence Financial SA was authorized by the FSMA to conduct business from Belgium.
        <br />
        <br />
        He started his career at the Brussels bar (Linklaters) and went on to serve as General Counsel, regionally for BNY Mellon (London) and JP Morgan (London) and globally for Clearstream (Luxembourg) and Dexia (Paris). From 2012 to 2015, he served as CEO of The Bank of New York Mellon SA.
        <br />
        <br />
        Wim holds a Lic. Iuris from the University of Leuven (Belgium) and a LL.M. from the University of Illinois (USA), as well as Postgraduate Diplomas in Financial Management from Solvay Business School (Belgium) and INSEAD (France).
      </>
    ),
    email: 'wim.hautekiet@quantessence.com',
    image: wim,
  },
  {
    id: 'team-member-4',
    icon: <FaLinkedin />,
    linkedin: 'https://www.linkedin.com/in/pavel-pluhacek-5a65214/',
    name: 'Pavel Pluhacek',
    title: 'Lead Developer',
    image: pavel,
    description: (
      <>
        Pavel is the Technology Lead at Quantessence. He is responsible for the
        design and operations of the Euroclear Quantessence Platform.
        <br />
        <br />
        With over 15 years of experience in software development within the
        financial industry, Pavel has contributed to major projects, including
        the successful launch of individualised CPPI trading at Barclays
        Investment Bank in 2012. He joined Quantessence in 2016 and has led the
        development team since then.
        <br />
        <br />
        Pavel holds a Master’s degree in Computer Science, specialising in
        systems programming and compiler design.
      </>
    ),
    email: 'pavel.pluhacek@quantessence.com',
  },

  {
    id: 'team-member-5',
    icon: <FaLinkedin />,
    linkedin: 'https://www.linkedin.com/in/olly-buxton-34595a23b/',
    name: 'Olly Buxton',
    title: 'General Counsel',
    description: (
      <>
        Olly has more than 30 years’ legal experience in the international
        capital markets. Over that time, he has specialised in secured lending,
        structured credit, structured notes, commodities, equity financing,
        collateral optimisation, prime brokerage, energy transition and asset
        financing.
        <br />
        <br />
        Prior to joining Quantessence, Olly was General Counsel at Tramontana
        Asset Management Limited and, before that, an in-house lawyer at UBS,
        Barclays Investment Bank and Goldman Sachs International, and in private
        practice at Linklaters in London and Kensington Swan in Wellington.
        <br />
        <br />
        Olly holds a Bachelor of Laws with First Class Honours from the
        University of Canterbury in Christchurch, New Zealand, and is admitted
        as a barrister and solicitor in New Zealand and as a solicitor in
        England and Wales.
      </>
    ),
    email: 'olly.buxton@quantessence.com',
    image: olly,
  },
  {
    id: 'team-member-6',
    icon: <FaLinkedin />,
    linkedin: 'https://www.linkedin.com/in/nicolas-schepkens-25a23a8/',
    name: 'Nicolas Schepkens',
    title: 'Director',
    description: (
      <>
        Nicolas Schepkens is Director in the Quantessence Board, representing
        Euroclear. At Euroclear, Nicolas is the COO of the Legal, Governance and
        Regulatory Division of the Euroclear Group and Head of Euroclear's
        IT/IP & Supply Chain Legal Team. He is a qualified lawyer with nearly
        two decades of experience in financial markets, banking, governance and
        corporate law.
        <br />
        <br />
        Prior to his current position, Nicolas served as Head of Euroclear's
        Banking and Collateral Management Legal Team and Head of the Governance
        Centre of Excellence. Before joining Euroclear, he practised as a
        lawyer at Ashurst and Liedekerke, focusing on banking, finance,
        restructuring and corporate transactions.
      </>
    ),
    email: 'nicolas.schepkens@euroclear.com',
    image: nicolas,
  },
  {
    id: 'team-member-7',
    icon: <FaLinkedin />,
    linkedin: 'https://www.linkedin.com/in/cecile-v-5193519/',
    name: 'Cécile Van Hentenryck',
    title: 'Chairwoman of the Board',
    description: (
      <>
        Cécile chairs the Board of Quantessence. At Euroclear, she is Head of
        Group Financial Performance & Corporate Finance. She holds various
        positions and Board mandates in the group.
        <br />
        <br />
        Before joining Euroclear in 2008, she worked during 8 years at PwC in
        financial audit services and M&A advisory services in Belgium and
        Canada. Cecile holds a Master's degree, cum laude, in Business
        Engineering from the Solvay Brussels School of Economics and Management.
      </>
    ),
    email: 'cecile.vanhentenryck@euroclear.com',
    image: cecile,
  },
];

export default team;